/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AlertDto, Transaction } from "../models/index";
import {
    AlertDtoFromJSON,
    AlertDtoToJSON,
    TransactionFromJSON,
    TransactionToJSON,
} from "../models/index";

export interface GetImpactedTransactionsODataRequest {
    alertId: number;
}

/**
 *
 */
export class AlertsHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * An OData endpoint that lists alerts visible for the current IlluminateUser.
     */
    async alertListODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<AlertDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/alerts-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(AlertDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists alerts visible for the current IlluminateUser.
     */
    async alertListOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<AlertDto>> {
        const response = await this.alertListODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * OData endpoint that returns impacted transactions for Alert based on AlertType.
     */
    async getImpactedTransactionsODataRaw(
        requestParameters: GetImpactedTransactionsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<Transaction>>> {
        if (requestParameters["alertId"] == null) {
            throw new runtime.RequiredError(
                "alertId",
                'Required parameter "alertId" was null or undefined when calling getImpactedTransactionsOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/alerts/{alertId}/impacted-transactions-odata`.replace(
                    `{${"alertId"}}`,
                    encodeURIComponent(String(requestParameters["alertId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TransactionFromJSON),
        );
    }

    /**
     * OData endpoint that returns impacted transactions for Alert based on AlertType.
     */
    async getImpactedTransactionsOData(
        requestParameters: GetImpactedTransactionsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<Transaction>> {
        const response = await this.getImpactedTransactionsODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
